<template>
  <div class="search">
    <div class="center">
      <!--左-->
      <div class="search_center">
        <div class="search_title">【关键字】我的搜索内容</div>
        <div class="nav_list">
          <div @click="handleToShow(1)" :class="{active:this.$route.query.id == 1}" class="item">相关视频</div>
          <div @click="handleToShow(2)" :class="{active:this.$route.query.id == 2}" class="item">相关语音</div>
          <div @click="handleToShow(3)" :class="{active:this.$route.query.id == 3}" class="item">相关文章</div>
          <div @click="handleToShow(4)" :class="{active:this.$route.query.id == 4}" class="item">相关问答</div>
          <div @click="handleToShow(5)" :class="{active:this.$route.query.id == 5}" class="item">相关医生</div>
        </div>
        <div class="router_center">
          <router-view/>
        </div>
      </div>
      <!--右-->
      <div class="search_list">
        <div class="Recommended_text">
          <div class="Recommended_title">推荐阅读</div>
          <div class="text_list">
            <div class="item_text">肝炎的早期症状有哪些呢？</div>
            <div class="item_text">肝炎的早期症状有哪些呢？</div>
            <div class="item_text">肝炎的早期症状有哪些呢？</div>
            <div class="item_text">肝炎的早期症状有哪些呢？</div>
            <div class="item_text">肝炎的早期症状有哪些呢？</div>
            <div class="item_text">肝炎的早期症状有哪些呢？</div>
            <div class="item_text">肝炎的早期症状有哪些呢？</div>
            <div class="item_text">肝炎的早期症状有哪些呢？</div>
            <div class="item_text">肝炎的早期症状有哪些呢？</div>
            <div class="item_text">肝炎的早期症状有哪些呢？</div>
          </div>
        </div>
        <div class="Recommended_video">
          <div class="Recommended_title">推荐阅读</div>
          <div class="video_list">
            <div class="item_video active">
              <div class="classOne">
                <img src="../../../assets/images/home/u1791.png" alt="">
                <div>肝炎的早期症状有哪些呢</div>
              </div>
              <div class="classTwo">
                <img src="../../../assets/images/home/u1776.png" alt="">
                <div>肝炎的早期症状有哪些呢</div>
              </div>
            </div>
            <div class="item_video active">
              <div class="classOne">
                <img src="../../../assets/images/home/u1791.png" alt="">
                <div>肝炎的早期症状有哪些呢</div>
              </div>
              <div class="classTwo">
                <img src="../../../assets/images/home/u1776.png" alt="">
                <div>肝炎的早期症状有哪些呢</div>
              </div>
            </div>
            <div class="item_video active">
              <div class="classOne">
                <img src="../../../assets/images/home/u1791.png" alt="">
                <div>肝炎的早期症状有哪些呢</div>
              </div>
              <div class="classTwo">
                <img src="../../../assets/images/home/u1776.png" alt="">
                <div>肝炎的早期症状有哪些呢</div>
              </div>
            </div>
            <div class="item_video">
              <div class="classOne">
                <img src="../../../assets/images/home/u1791.png" alt="">
                <div>肝炎的早期症状有哪些呢</div>
              </div>
              <div class="classTwo">
                <img src="../../../assets/images/home/u1776.png" alt="">
                <div>肝炎的早期症状有哪些呢</div>
              </div>
            </div>
            <div class="item_video">
              <div class="classOne">
                <img src="../../../assets/images/home/u1791.png" alt="">
                <div>肝炎的早期症状有哪些呢</div>
              </div>
              <div class="classTwo">
                <img src="../../../assets/images/home/u1776.png" alt="">
                <div>肝炎的早期症状有哪些呢</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Search",
    data(){
      return {

      }
    },
    methods:{
      handleToShow(id){
        if(!id){
          id=1
        }
        this.$router.push({path:'/tt/search/searchList'+'.html',query:{id:id,val:this.$route.query.val}})
      }
    },
    mounted() {
      this.handleToShow()
    }
  }
</script>
<style lang="stylus" scoped>
  div{
    box-sizing border-box
  }
  .search{
    margin-top 40px
    .center{
      width: 1200px
      margin 0 auto
      display flex
      justify-content space-between
      .search_center{
        width: 841px
        .search_title{
          font-weight: 700;
          font-style: normal;
          font-size: 18px;
          text-align: center
          height: 40px
          line-height:40px
          &:after{
            content ''
            display block
            width: 100%
            height: 1px
            background #d2d2d2
            margin-top 10px
          }
        }
        .nav_list{
          display flex
          margin 30px 0 20px 0
          .item{
            font-weight: 700;
            font-size: 16px;
            display flex
            cursor: pointer
            &:after{
              content ''
              display block
              width: 1px
              height: 20px
              background #d2d2d2
              margin 0 15px
            }
            &.active{
              color: rgb(99,163,252)
            }
            &:hover{
              color: rgb(99,163,252)
            }
          }
        }
        .router_center{
          width: 841px
        }
      }
      //右
      .search_list {
        width: 330px
        .Recommended_text{
          .Recommended_title{
            width: 170px;
            height: 40px;
            border-radius: 5px;
            font-weight: 700;
            font-size: 18px;
            background #1083f8
            text-align: center
            line-height:40px
            color: #fff
          }
          .text_list{
            margin-top 20px
            border 1px solid #d7d7d7
            width: 100%
            padding 15px 15px 20px 15px
            .item_text{
              ont-weight: 700;
              font-size: 14px;
              margin-bottom 25px
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              cursor: pointer
              font-weight: 700;
              &:last-child{
                margin-bottom 0px
              }
            }
          }
        }
        .Recommended_video {
          .Recommended_title{
            width: 170px;
            height: 40px;
            border-radius: 5px;
            font-weight: 700;
            font-size: 18px;
            background #1083f8
            text-align: center
            line-height:40px
            color: #fff
          }
          .video_list{
            margin-top 20px
            border 1px solid #d7d7d7
            width: 100%
            padding 15px 15px 20px 15px
            .item_video{
              margin-bottom 25px
              &:last-child{
                margin-bottom 0px
              }
              .classOne{
                display flex
                align-items center
                >img{
                  width: 28px
                  height: 20px
                  margin-right 10px
                }
                >div{
                  width 100%-40px
                  font-size: 14px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  cursor: pointer
                  color: #868888
                }
              }
              .classTwo{
                display none
                align-items center
                >img{
                  width: 28px
                  height: 20px
                  margin-right 10px
                }
                >div{
                  width 100%-40px
                  font-size: 14px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  cursor: pointer
                  color: #FF7172
                }
              }

              &.active{
                .classTwo{
                  display flex
                }
                .classOne{
                  display none
                }
              }
            }
          }
        }
      }
    }
  }
</style>





// WEBPACK FOOTER //
// src/views/view-tt/search/Search.vue